import { useMemo } from "react";
import { useQuery } from "react-query";
import { getDiscount, getDiscountBySKU, getPrice, magento, } from "@jti/magento";
export const useProductDetails = ({ sku, currentVariantSku, pageSize = 1 }) => {
    const queryState = useQuery({
        queryKey: ["GET_PRODUCT_DETAILS_BY_SKU", sku, currentVariantSku, pageSize],
        queryFn: () => magento.getProductsDetailsBySku([sku], pageSize),
    });
    const productData = queryState.data?.products?.items?.[0];
    const isConfigurableProduct = productData?.__typename === "ConfigurableProduct";
    const discount = useMemo(() => isConfigurableProduct
        ? getDiscountBySKU(currentVariantSku, productData)
        : getDiscount(productData), [productData, isConfigurableProduct, currentVariantSku]);
    const priceInformation = useMemo(() => getPrice(sku, currentVariantSku, productData), [productData, sku, currentVariantSku]);
    return {
        ...queryState,
        discount,
        priceInformation,
    };
};
//# sourceMappingURL=useProductDetails.js.map